import { InstalledSoftware } from "@/model/data/InstalledSoftware";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { Installation } from "../Installation";
import { SmartLock } from "./SmartLock";

export class InstallationSmartLockStatus extends Installation {
    agent: Array<InstalledSoftware> = null;
    smartLocks: Map<string, SmartLock>;
    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);

        if (obj.AgentInfo && obj.AgentInfo.Version) {
            this.agent = new Array<InstalledSoftware>();
            let agentSoftware = new InstalledSoftware();
            agentSoftware.name = "Agent";
            agentSoftware.version = obj.AgentInfo.Version;
            agentSoftware.updateType = UpdateTypeEnum.Agent;
            this.agent.push(agentSoftware);
        }

        if (obj.SmartLocks) {
            this.smartLocks = new Map<string, SmartLock>();
            Object.entries(obj.SmartLocks).forEach((pair: any) => {
                if (pair[1]) {
                    let s = new SmartLock();
                    s.parse(pair[1]);
                    this.smartLocks.set(pair[0], s);
                }
            });
        }
    }
}
